import { CgImage } from "react-icons/cg";
import { useRef, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";

import { useMutation } from "@apollo/client";
import { useAuthContext } from "../hooks/useAuthContext";
import { ADD_POST } from '../mutations/postMutations';
import { toast } from "react-hot-toast";
import EmojiPicker from "./EmojiPicker";

export default function CreatePost({ refetch }) {
  const { authUser } = useAuthContext()

  const [content, setContent] = useState("")
  const [image, setImage] = useState(null)
  const [isPosting, setIsPosting] = useState(false)
  const [error, setError] = useState(null)

  const imgRef = useRef(null)

  const [createPost] = useMutation(ADD_POST, {
    variables: { content, userId: authUser.id, image },
	onCompleted: () => {
	  toast.success("Post created successfully")

	  refetch()
	  setContent("")
	  setImage(null)
	  setIsPosting(false)
	  setError(null)
	},
	onError: (error) => {
	  toast.error(error.message)
	  setIsPosting(false)
	  setError(error.message)
	}
  })

  const handleSubmit = (e) => {
    e.preventDefault()
	setIsPosting(true)
	
	if (content === '') {
	  setError('Please write some content to post!')
	  toast.error('Please write some content to post!')
	  setIsPosting(false)
	  return
	}

	createPost({ variables: { content, userId: authUser.id, image } })
  }

  const handleImgChange = (e) => {
    const file = e.target.files[0]
	if (file) {
	  const reader = new FileReader()
	  reader.onload = () => {
	    setImage(reader.result)
	  }
	  reader.readAsDataURL(file)
	}
  }

  return (
	<div className='d-flex p-2 items-align-start border rounded border-secondary'>
	  {/*<div className='d-none d-md-inline avatar'>
	    <img className="w-100 h-0 rounded-circle" src={authUser?.profileImg || "/gunslinger.jpg"} />
  	  </div>*/}

	  <form className='d-flex flex-column ms-2 p-2 w-100' onSubmit={handleSubmit}>
	    <textarea
		  className={`textarea w-100 rounded p-2 ${error ? 'border border-danger' : 'border-none'}`}
		  style={{ resize: 'none' }}
		  placeholder={`${error ? error : 'What is happening?!'}`}
		  value={content}
		  onChange={(e) => setContent(e.target.value)}
		/>

		{image && (
		  <div className='position-relative w-72 mx-auto'>
		    <IoCloseSharp
			  className='position-absolute top-0 right-0 text-white bg-secondary rounded-circle w-5 h-5 cursor-pointer'
			  onClick={() => {
			    setImage(null)
				imgRef.current.value = null
			  }}
			/>
			  <img src={image} className='w-100 mx-auto h-72 object-contain rounded' alt='' />
		  </div>
		)}

		<div className='d-flex justify-content-between border-t py-2 border-t-secondary'>
		  <button className='btn btn-sm btn-violet'>
			<div className="rfs-4">
			  {isPosting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
			  {isPosting ? "Posting..." : "Post"}
			</div>
		  </button>

		  <div className='d-flex position-relative items-align-center'>
			<CgImage
			  className='text-rose rfs-4 my-auto mx-1 cursor-pointer'
			  onClick={() => imgRef.current.click()}
			/>

			<EmojiPicker content={content} setContent={setContent} />
		  </div>

		  <input type='file' accept='image/*' hidden ref={imgRef} onChange={handleImgChange} />
		</div>
	  </form>
	</div>
  )
}
